import { useEffect, useState } from "react";
import { FlaskConical, Rocket } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { apiAdminEnvironment } from "../adminApi";

// Etichetta Anteprima/Produzione calcolata lato server con la stessa
// is_preview_environment() usata per bloccare gli invii automatici reali.
export const EnvironmentBadge = ({ className = "" }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    let mounted = true;
    apiAdminEnvironment()
      .then((d) => { if (mounted) setPreview(!!d.preview); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (preview === null) return null;

  return preview ? (
    <Badge
      className={`gap-1.5 border-0 bg-carrot/15 text-carrot ${className}`}
      data-testid="environment-badge-preview"
    >
      <FlaskConical className="h-3.5 w-3.5" /> Anteprima
    </Badge>
  ) : (
    <Badge
      className={`gap-1.5 border-0 bg-lime/15 text-lime ${className}`}
      data-testid="environment-badge-production"
    >
      <Rocket className="h-3.5 w-3.5" /> Produzione
    </Badge>
  );
};
